import { render, staticRenderFns } from "./chatFooter.vue?vue&type=template&id=117f7243"
import script from "./chatFooter.vue?vue&type=script&lang=js"
export * from "./chatFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports